function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-compare-remove_svg__a",
  d: "M7.183 20.166l1.665-1.758v2.805c0 .485-.372.878-.832.878H5.359l1.665-1.757h.16v-.168zm8.325-5.984v7.03c0 .486-.372.88-.833.88h-4.162c-.46 0-.833-.394-.833-.88V17.53l1.665-1.757v4.562h2.498V15.06h-1.824l1.664-1.758h.992c.46 0 .833.395.833.88zm2.497 6.182h2.497v-1.787h-2.497v1.787zm3.33-3.546h-4.162c-.46 0-.833.395-.833.88v3.544c0 .485.372.88.833.88h4.162c.46 0 .832-.395.832-.88v-3.545c0-.484-.372-.879-.832-.879zm1.42-2.015a.805.805 0 01-1.176 0l-3.691-3.895a4.758 4.758 0 01-2.38.638c-.052 0-.102-.006-.153-.007l5.14-5.426c0 .053.007.106.007.16 0 1.361-.496 2.6-1.3 3.536l3.554 3.752c.325.343.325.9 0 1.242zM4.686 9.788h2.498v5.442l-2.497 2.636V9.788zm7.493-3.515c0-1.939 1.493-3.515 3.33-3.515.959 0 1.819.435 2.425 1.124l-4.691 4.95a3.575 3.575 0 01-1.064-2.56zm9.268-4.858a.8.8 0 00-1.177 0l-1.163 1.228C18.196 1.637 16.926 1 15.508 1c-2.755 0-4.995 2.366-4.995 5.273 0 1.497.603 2.84 1.556 3.799l-3.221 3.4V8.909c0-.484-.372-.879-.832-.879H3.853c-.46 0-.832.395-.832.88v10.714L1.243 21.5a.914.914 0 000 1.243.81.81 0 00.589.257.808.808 0 00.589-.257L21.446 2.657a.914.914 0 000-1.242z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("use", {
  fillRule: "evenodd",
  xlinkHref: "#icon-compare-remove_svg__a"
});

var SvgIconCompareRemove = function SvgIconCompareRemove(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgIconCompareRemove;